module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-panel-container",
    class: {
      active: _vm.open
    },
    on: {
      "click": _vm.setActive
    }
  }, [_c('section', {
    staticClass: "notification-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "head row"
  }, [_c('span', {
    staticClass: "icon-volet-notif"
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tNotifications\n\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "close icon-form-close",
    on: {
      "click": _vm.setActive
    }
  })]), _vm._v(" "), (_vm.isClient) ? _c('div', {
    staticClass: "custom-notif ctn-free-trial notification"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tVous disposez d'un essai gratuit\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\tJusqu'au 02/01/2019\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.goToAbo
    }
  }, [_vm._v("\n\t\t\t\tRenouveler maintenant\n\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "custom-notif ctn-next-appointment notification"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tVotre prochain rendez-vous\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\tLundi 04 Mars 2018 de 14h à 16h\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "advisor row"
  }, [_c('div', {
    staticClass: "ctn-profile-picture"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.picture,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-notifications"
  }, _vm._l((_vm.notifications), function(notification, key) {
    return _c('div', {
      key: key,
      staticClass: "notification"
    }, [(notification.type === 'article') ? _c('div', {
      staticClass: "head-notif row"
    }, [_c('span', {
      staticClass: "icon-notif-article"
    }), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v("Nouvel Article")]), _vm._v(" "), _c('div', {
      staticClass: "hour"
    }, [_vm._v(_vm._s(_vm._f("moment")(notification.date, 'HH[h]mm')))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "body-notif"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(notification.text) + "\n\t\t\t\t")])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\tAvec "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mr Pitois")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Points à aborder :")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Assurance vie / Immobilier")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-321f7ed4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/notification-panel.vue
// module id = 1099
// module chunks = 0